import { QueryResult, useQuery } from '@apollo/client';
import { AuthRole } from '@bechtel/types';
import { GET_ROLES } from '@bechtel/client-gql';

export function useRoleQuery(fetchFromNetwork?: boolean): QueryResult<{ roles: AuthRole[] }> {
  const response = useQuery<{ roles: AuthRole[] }>(
    GET_ROLES,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
